"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ThemeFields;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ThemeFields(_ref) {
  var field = _ref.field,
    form = _ref.form,
    _ref$hideColorScheme = _ref.hideColorScheme,
    hideColorScheme = _ref$hideColorScheme === void 0 ? false : _ref$hideColorScheme,
    _ref$showCustomColor = _ref.showCustomColor,
    showCustomColor = _ref$showCustomColor === void 0 ? true : _ref$showCustomColor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideColorScheme && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(field.name, ".colors")
  }, function (props) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({}, props, {
      label: "Color Scheme"
    }), /*#__PURE__*/_react["default"].createElement("select", _extends({
      className: "form-control"
    }, props, props.field), showCustomColor && /*#__PURE__*/_react["default"].createElement("option", {
      value: "custom"
    }, "Custom"), /*#__PURE__*/_react["default"].createElement("optgroup", {
      label: "Categorical Colors"
    }, [{
      label: 'Category 10',
      value: 'category10'
    }, {
      label: 'Accent',
      value: 'accent'
    }, {
      label: 'Dark 2',
      value: 'dark2'
    }, {
      label: 'Paired',
      value: 'paired'
    }, {
      label: 'Pastel 1',
      value: 'pastel1'
    }, {
      label: 'Pastel 2',
      value: 'pastel2'
    }, {
      label: 'Set 1',
      value: 'set1'
    }, {
      label: 'Set 2',
      value: 'set2'
    }, {
      label: 'Set 3',
      value: 'set3'
    }].map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option.value,
        value: option.value,
        disabled: option.disabled
      }, option.label);
    })), /*#__PURE__*/_react["default"].createElement("optgroup", {
      label: "Sequential Colors"
    }, [{
      label: 'Blues',
      value: 'blues'
    }, {
      label: 'Greens',
      value: 'greens'
    }, {
      label: 'Greys',
      value: 'greys'
    }, {
      label: 'Oranges',
      value: 'oranges'
    }, {
      label: 'Purples',
      value: 'purples'
    }, {
      label: 'Reds',
      value: 'reds'
    }].map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option.value,
        value: option.value,
        disabled: option.disabled
      }, option.label);
    }))));
  }), field.value.colors === 'custom' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(field.name, ".customColors"),
    component: _cccisdFormik.CccisdColorPicker
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Font Size",
    name: "".concat(field.name, ".theme.fontSize"),
    component: _cccisdFormik.CccisdSelect,
    options: [{
      label: 'Small',
      value: '11'
    }, {
      label: 'Medium',
      value: '14'
    }, {
      label: 'Large',
      value: '18'
    }]
  }));
}